"use client"
import ErrorPage from "@/components/ErrorPages/ErrorPage"

export default function Error(): React.ReactElement {
  return <ErrorPage type="internal-error" />
}
